
// import { methodSchemas, dashboardSchema, reportListSchema } from './schemas'
import moment from 'moment-timezone';
import { DashboardT } from './containers/DashboardTemplate';

/**
 * Ticketing dashboard impl
 * 
 */


class TicketingAdminDashboard extends DashboardT {
     constructor(options){
         super(options);
     }

    // getPropsFilterValues({profile}){
    //     let agentFilter = 
    //     {
    //         field: 'agent',
    //         operator: 'eqOrEmpty',
    //         value: profile.preferred_username
    //     }
    //     if(!this.apisMeta.pageMetrics.filters.some(f=> f.field === 'agent')){
    //         this.apisMeta.pageMetrics.filters.push(agentFilter);
    //     }
    //     return ;
    // }
}

let now = new Date()
let nowF = moment(now).format('YYYY-MM-DD')
let setDate = now.setDate(now.getDate() -30)
let monthBegin = setDate
let monthBeginF =
    moment(monthBegin).tz(moment.tz.guess()).format('YYYY-MM-DD')
const apisMeta = {
    pageMetrics: {
        name: 'pageMetrics',
        filters: [{
            field: 'objectCreatedDate',
            operator: 'is within',
            values: [monthBeginF, nowF]
        },{
            field: 'state',
            operator: 'notIn',
            value: ["Deleted","Unregistered"]
        }
        ],
        select: ["category", "metricName", "createdAt", "objectCreatedDate", "state", "objectId", "source","queue","queueTime","queueName",'agentName','ticketOpenCount','resolvedByBot'],
        groupByAgg: [{"field": "sum", "operation": "sum", "as": "metric"}],
        path: 'bpm/analytics',
        method: 'POST',
        orderBy: [{ field: 'createdAt', order: 'desc' }]
    }
}

const chartsMeta = {
    ticketByStatus: {
        name: 'ticketByStatus',
        title: 'Tickets by Status',
        chartType: 'pie',
        dimension: 'state',
        metricName: 'count',
        height : 200
    },
    ticketByChannel: {
        name: 'ticketByChannel',
        title: 'Tickets by Channel',
        chartType: 'pie',
        dimension: 'source',
        metricName: 'count',
        height : 200
    },
    resolutionTime: {
        name: 'resolutionTime',
        title: 'Resolution Time (hrs)',
        chartType: 'lines',
        operator: 'avg',
        dimension:'createdAtNew',
        metricName: 'queueTime',
        height : 200
    },
    ticketByQueueAndStatus: {
        name: 'ticketByQueueAndStatus',
        title: 'Ticket by Queue & Status',
        chartType: 'bars',
        dimension: 'queueName*finalState',
        stackNeeded: [{key:'Open', color: '#FEA47F'}, {key:'Closed', color: '#25CCF7'}],
        metricName: 'count',
        height : 200
    },
    firstResponseTime: {
        name: 'firstResponseTime',
        title: 'First Response Time (mins)',
        chartType: 'lines',
        dimension:'createdAtNew',
        operator: 'avg',
        metricName: 'firstReplyTime',
        height : 200
    },
    botPerformance: {
        name: 'botPerformance',
        title: 'Bot Performance',
        chartType: 'bars',
        dimension: 'createdAt*botTicketStatus',
        stackNeeded: [{key:'Ticket Resolved', color: '#F97F51'}, {key:'Service Desk', color: '#1B9CFC'}],
        defaultFilters: ['ChatBot-Web','ChatBot-MSTeams','ChatBot-Mobile','Slack'],
        metricName: 'count',
        height : 200
    },
    agentPerformance: {
        name: 'agentPerformance',
        title: 'Agent Performance',
        chartType: 'bars',
        dimension: 'agentName*agentState',
        stackNeeded: [{key:'Assigned', color: '#9AECDB'}, {key:'Solved', color: '#D6A2E8'}],
        metricName: 'count',
        height : 200
    },
    ticketByCategory: {
        name: 'ticketByCategory',
        title: 'Ticket by Category',
        chartType: 'treemap',
        height : 200
    },
}
const fieldsMeta = {
    DateFilter: {
        label: 'DateFilter',
        name: 'DateFilter',
        type: 'date-slider',
        dimension: 'createdAt'
    }
}

const sectionsMeta = {
    headerComponent: {
        component: 'DetailHeader',
    },

    filters: {
        items: [{ name: 'DateFilter', type: 'field', col: 1 }],
        cols: [12]
    },
    mySection:{
       cols: [4,4,4],
       items: [{ name: 'ticketByStatus', type: 'chart', col: 1},{ name: 'ticketByChannel', type: 'chart', col: 2},{ name: 'resolutionTime', type: 'chart', col: 3}]
    },
    mySection1:{
        cols: [6,6],
        items: [{ name: 'ticketByQueueAndStatus', type: 'chart', col: 1},{ name: 'firstResponseTime', type: 'chart', col: 2}]
     },
    mySection2:{
        cols: [6,6],
        items: [{ name: 'botPerformance', type: 'chart', col: 1}, { name: 'agentPerformance', type: 'chart', col: 2}]
     },
     mySection3:{
        cols: [6,6],
        items: [{ name: 'ticketByCategory', type: 'chart', col: 1}]
     },
    content : {
        items: [
            { name: 'filters', type: 'section'},
            { name: 'mySection', type: 'section' },
            { name: 'mySection1', type: 'section' },
            { name: 'mySection2', type: 'section' },
            { name: 'mySection3', type: 'section' }
        ]
    },
    
}

const dashboardMeta = {
    items: [{ name: 'content', type: 'section' } 
    ],
    classes: 'composite-form',
    title: 'Ticketing Admin Dashboard',
    apis: ['pageMetrics'],
    dimensions: ['category', 'createdAt','createdAtNew','queue','source','state','queueTime','queueName*finalState','agentName*agentState','firstReplyTime','createdAt*botTicketStatus','createdDate']
}

const TicketingDashboard = new TicketingAdminDashboard({ fieldsMeta, sectionsMeta, dashboardMeta, apisMeta, chartsMeta, name: 'TicketingDashboard', title: 'Ticketing Dashboard' })

const TicketingDashboardContainer = TicketingDashboard.getContainer('Dashboard')
export { TicketingDashboardContainer };

